import React from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { errMsg } from "../admin/ui";

export const fmtQty = (n) => new Intl.NumberFormat("id-ID", { maximumFractionDigits: 0 }).format(n || 0);
export const perLabel = (q) => (q && q !== 1 ? ` / ${fmtQty(q)}` : " / unit");
export const valueOf = (qty, d) => Math.round((qty * d.price_per_unit_idr) / (d.price_per_qty || 1) * 100) / 100;

export const MODES = {
  partial: { label: "PARTIAL TAKE", desc: "Supplier boleh mengambil sebagian demand" },
  take_all: { label: "TAKE ALL", desc: "Supplier wajib mengambil seluruh sisa demand" },
  minimum: { label: "MINIMUM TAKE", desc: "Boleh sebagian, tapi tidak kurang dari minimum" },
};

const DSTATUS = {
  draft: ["DRAFT", "text-[#A8A8AD] border-[#35353B]"],
  open: ["OPEN", "text-[#35C78A] border-[#35C78A]"],
  filled: ["FILLED", "text-[#D4AF37] border-[#D4AF37]"],
  closed: ["DITUTUP", "text-[#F06464] border-[#F06464]"],
};
const ASTATUS = {
  committed: ["BERJALAN", "text-[#5FC3F0] border-[#5FC3F0]"],
  cancel_requested: ["MINTA BATAL", "text-[#F2D98D] border-[#F2D98D]"],
  completed: ["SELESAI", "text-[#35C78A] border-[#35C78A]"],
  cancelled: ["DIBATALKAN", "text-[#F06464] border-[#F06464]"],
};
export const FAULTS = { supplier: "Kesalahan supplier (pelanggaran)", admin: "Kesalahan Owner/Admin (tanpa penalti)", external: "Di luar kendali supplier (tanpa penalti)" };

export function StatusBadge({ status, kind = "demand", testId }) {
  const [label, cls] = (kind === "demand" ? DSTATUS : ASTATUS)[status] || [status, "text-[#A8A8AD] border-[#35353B]"];
  return <span data-testid={testId} className={`inline-block px-2 py-0.5 border rounded-sm text-[10px] font-bold tracking-widest ${cls}`}>{label}</span>;
}

export function ProgressBar({ d }) {
  const pct = Math.min(100, (d.taken_qty / d.target_qty) * 100);
  return (
    <div className="h-1.5 bg-[#101114] rounded-full overflow-hidden">
      <div className="h-full bg-gradient-to-r from-[#8C6D1F] via-[#D4AF37] to-[#F2D98D] transition-[width] duration-700" style={{ width: `${pct}%` }} />
    </div>
  );
}

export function Stars({ rating }) {
  if (rating == null) return <span className="text-xs text-[#A8A8AD]">Belum ada rating</span>;
  return <span className="text-[#D4AF37] font-bold text-sm">★ {rating.toFixed(1)}<span className="text-[#A8A8AD] font-normal text-xs"> / 5</span></span>;
}

export async function openJobChat(navigate, body) {
  try {
    const r = await api.post("/demand-chat", body);
    navigate(`/chat?c=${r.data.id}`);
  } catch (e) { toast.error(errMsg(e)); }
}
